import { render, staticRenderFns } from "./pertuk.vue?vue&type=template&id=4609af4d"
import script from "./pertuk.vue?vue&type=script&lang=js"
export * from "./pertuk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports